import type { HeadCell } from 'modules/core/components/DataTable/types'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import useData from './useData'
import useProjections from './useProjections'

const useHeader = <T, S extends string>() => {
  const { source } = useData<T, S>()
  const { projections } = useProjections<T, S>()

  return useUnsafeMemo(() => {
    return projections.map((projection) => {
      let headCell: HeadCell<S> = {
        id: projection.identifier,
        width: projection.width,
        colSpan: projection.colSpan,
        textAlign: projection.textAlign,
        justifyContent: projection.justifyContent,
        sticky: 'sticky' in projection ? projection.sticky : false,
        title: 'title' in projection ? projection.title : undefined,
        tooltip: 'tooltip' in projection ? projection.tooltip : undefined,
      }

      if ('sortBy' in projection) {
        headCell = {
          ...headCell,
          sortPath: projection.sortBy,
        }
      } else if (
        'path' in projection &&
        source.sort.fields.includes(projection.path as unknown as S)
      ) {
        headCell = {
          ...headCell,
          sortPath: projection.path as unknown as S,
        }
      }

      return headCell
    })
  }, [projections, source.sort.fields])
}

export default useHeader
